import { Formule } from "./formule";

export class Abonnement {
    id: number;
    clientId : string; 
    dateDernierPaiement: Date;
    dateProchainPaiement: Date;
    dateDebut : Date;
    dateFin : Date;
    formuleId: number;
    isActive: Boolean;
    isReconduct: Boolean;
    nbPaiementsEffectues: number;
    isExpanded : Boolean = false;
    formule : Formule;
    recurrence : Boolean;
    paiementMod : string;
}
